import { RedeemScreen } from '@/screens/diamonds/RedeemScreen'

export default function () {
  return (
    <RedeemScreen />
  )
}
